<template lang="pug">
.container-fluid
	.card
		.card-header.bg-dark.text-white
			span.fa.fa-search.mr-2
			| Buscador de noticias
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-3
					.form-group
						label
							b Texto
						input.form-control(v-model="filtro.Texto", placeholder="Buscar en el título, contenido, etiquetas, palabras clave...", @keypress.enter="buscar()")
					.form-group
						label
							b Autor
						input.form-control(v-model="filtro.Autor", placeholder="Autor de la noticia", @keypress.enter="buscar()")
				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-3
					.form-group
						label
							b Desde
						.input-group
							datepicker(
								placeholder="Fecha de inicio"
								:monday-first="true"
								:bootstrap-styling="true"
								input-class="form-control"
								:language="$dateLang"
								v-model="filtro.FechaIni"
								@input="buscar()"
							)
							.input-group-append
								button.btn.btn-danger(@click="filtro.FechaIni = null")
									span.fa.fa-trash
					.form-group
						label
							b Hasta
						.input-group
							datepicker(
								placeholder="Fecha de fin"
								:monday-first="true"
								:bootstrap-styling="true"
								input-class="form-control"
								:language="$dateLang"
								v-model="filtro.FechaFin"
								@input="buscar()"
							)
							.input-group-append
								button.btn.btn-danger(@click="filtro.FechaFin = null")
									span.fa.fa-trash
				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-3
					.form-group
						label
							b Categorias
						input-query(
							url="redaccion/php/api/buscar-categorias.php"
							placeholder="Busca una categoria"
							:realtime="true"
							@selected="seleccionaCategoria($event)"
							input-class="form-control"
						)
					table.table.table-striped(v-if="filtro.Categorias.length > 0")
						tbody
							tr(v-for="cat in filtro.Categorias", :key="cat.CategoriaID")
								td.text-left {{cat.Titulo}}
								td.text-right.text-danger
									span.fa.fa-trash(@click="quitarCategoria(cat)", style="cursor:pointer;")

				.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-3
					.form-group
						label
							b Nevera
						br
						.btn-group
							button.btn(
								@click="toggleNevera()"
								:class="(filtro.verNevera) ? 'btn-primary' : ''"
							)
								span.fa.fa-snowflake-o.mr-2
								| Ver nevera
		.card-footer
			button.btn.btn-primary.mr-2(@click="buscar")
				span.fa.fa-search.mr-2
				| Buscar
			button.btn.btn-success.mr-2(@click="$router.push('/main/redaccion/editor/nueva')")
				span.fa.fa-edit.mr-2
				| Nueva
	Resultados.mt-3(v-if="resultados.length > 0", :resultados="resultados")
</template>

<script>
import Resultados from './resultados'
import { mapGetters, mapActions } from 'vuex'
export default {
	components: {
		Resultados
	},
	data () {
		return {
			filtro: {
				Texto: '',
				Autor: '',
				FechaIni: new Date(new Date().getTime() - 604800000),
				FechaFin: new Date(),
				Categorias: [],
				verNevera: false
			}
		}
	},
	created () {
		if (this.resultados.length === 0) {
			this.buscar()
		}
	},
	computed: {
		...mapGetters({
			resultados: 'redaccion/resultados'
		})
	},
	methods: {
		...mapActions({
			buscarNoticias: 'redaccion/buscar'
		}),
		toggleNevera () {
			this.filtro.verNevera = !this.filtro.verNevera
			this.buscar()
		},
		seleccionaCategoria (ev) {
			this.filtro.Categorias = [
				{
					Titulo: ev.datos.Titulo,
					CategoriaID: ev.datos.CategoriaID
				}
			]

			this.buscar()
		},
		quitarCategoria (Categoria) {
			this.filtro.Categorias.splice(this.filtro.Categorias.indexOf(Categoria))
			this.buscar()
		},
		buscar () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.FechaIni = (this.filtro.FechaIni) ? Math.floor(this.filtro.FechaIni / 1000) : null
			form.FechaFin = (this.filtro.FechaFin) ? Math.floor(this.filtro.FechaFin / 1000) : null

			this.buscarNoticias(form)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/buscador/buscador.vue